import * as React from 'react';

import { IconProps } from 'components/icons/types';

function HeadlinerColor(props: IconProps) {
  return (
    <svg
      width="151px"
      height="27px"
      viewBox="0 0 151 27"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      {...props}
    >
      <title>47CC6553-896D-46BF-8345-78A88C45B77F</title>
      <defs>
        <path
          d="M9.85,18.2642591 L9.85,24.2713271 C9.85,25.7780786 11.136,26.9990506 12.723,26.9990506 C14.31,26.9990506 15.596,25.7780786 15.596,24.2713271 L15.596,2.72772347 C15.596,1.22097194 14.31,0 12.723,0 C11.137,0 9.85,1.22097194 9.85,2.72772347 L9.85,15.0884028 L5.746,15.0884028 L5.746,2.72772347 C5.746,1.22097194 4.46,0 2.873,0 C1.286,0 0,1.22097194 0,2.72772347 L0,24.2722765 C0,25.7790281 1.286,27 2.873,27 C4.46,27 5.746,25.7790281 5.746,24.2722765 L5.746,18.2652085 L9.85,18.2652085 L9.85,18.2642591 Z M25.813,15.0884028 L25.813,5.55893523 L29.432,5.55893523 C31.049,5.55893523 32.359,4.31422744 32.359,2.77994233 C32.359,1.24470779 31.049,0 29.432,0 L22.94,0 C21.353,0 20.067,1.22097194 20.067,2.72772347 L20.067,24.2200577 C20.067,25.7552922 21.378,26.9990506 22.994,26.9990506 L29.431,26.9990506 C31.048,26.9990506 32.358,25.7543428 32.358,24.2200577 C32.358,22.6848231 31.047,21.4410648 29.431,21.4410648 L25.812,21.4410648 L25.812,18.2642591 L29.586,18.2642591 C30.51,18.2642591 31.259,17.5531331 31.259,16.6758562 C31.259,15.7985794 30.51,15.0874534 29.586,15.0874534 L25.813,15.0874534 L25.813,15.0884028 Z M41.776,18.2642591 L41.776,24.2713271 C41.776,25.7780786 40.49,26.9990506 38.903,26.9990506 C37.316,26.9990506 36.03,25.7780786 36.03,24.2713271 L36.03,7.40368521 C36.03,3.31447359 39.521,0 43.828,0 C48.135,0 51.626,3.31447359 51.626,7.40368521 L51.626,24.2713271 C51.626,25.7780786 50.34,26.9990506 48.753,26.9990506 C47.166,26.9990506 45.88,25.7780786 45.88,24.2713271 L45.88,18.2642591 L41.776,18.2642591 Z M45.88,15.0884028 L45.88,7.5071735 C45.88,6.43146494 44.961,5.55893523 43.828,5.55893523 C42.695,5.55893523 41.776,6.43146494 41.776,7.5071735 L41.776,15.0874534 L45.88,15.0874534 L45.88,15.0884028 Z M93.909,24.2722765 L93.909,2.72772347 C93.909,1.22097194 92.623,0 91.036,0 C89.449,0 88.163,1.22097194 88.163,2.72772347 L88.163,24.2722765 C88.163,25.7790281 89.449,27 91.036,27 C92.623,27 93.909,25.7780786 93.909,24.2722765 Z M104.348,14.4950067 C104.348,14.4950067 108.502,24.8998523 108.616,25.1818342 C109.046,26.2461495 110.075,27 111.325,27 C112.912,27 114.198,25.7790281 114.198,24.2722765 L114.198,2.72772347 C114.198,1.22097194 112.912,0 111.325,0 C109.738,0 108.452,1.22097194 108.452,2.72772347 L108.452,12.9730642 L104.184,1.81816583 C103.79,0.758597651 102.726,0 101.475,0 C99.888,0 98.602,1.22097194 98.602,2.72772347 L98.602,24.2722765 C98.602,25.7790281 99.888,27 101.475,27 C103.062,27 104.348,25.7790281 104.348,24.2722765 L104.348,14.4950067 Z M82.407,27 C84.024,27 85.334,25.7552922 85.334,24.2210071 C85.334,22.6857726 84.023,21.4420142 82.407,21.4420142 L81.23,21.4420142 L81.23,2.72772347 C81.23,1.22097194 79.944,0 78.357,0 C76.77,0 75.484,1.22097194 75.484,2.72772347 L75.484,24.2722765 C75.484,25.7790281 76.77,27 78.357,27 L82.407,27 Z M124.549,15.0884028 L124.549,5.55893523 L128.168,5.55893523 C129.785,5.55893523 131.095,4.31422744 131.095,2.77994233 C131.095,1.24470779 129.784,0.000949433856 128.168,0.000949433856 L121.676,0.000949433856 C120.089,0.000949433856 118.803,1.22192137 118.803,2.7286729 L118.803,24.2200577 C118.803,25.7552922 120.114,26.9990506 121.73,26.9990506 L128.167,26.9990506 C129.784,26.9990506 131.094,25.7543428 131.094,24.2200577 C131.094,22.6848231 129.783,21.4410648 128.167,21.4410648 L124.548,21.4410648 L124.548,18.2642591 L128.138,18.2642591 C129.062,18.2642591 129.811,17.5531331 129.811,16.6758562 C129.811,15.7985794 129.062,15.0874534 128.138,15.0874534 L124.549,15.0874534 L124.549,15.0884028 Z M58.97,27 C57.383,27 56.097,25.7790281 56.097,24.2722765 L56.097,2.72772347 C56.097,1.22097194 57.384,0 58.97,0 L63.637,0 C67.944,0 71.435,3.31447359 71.435,7.40368521 L71.435,19.5953654 C71.435,23.684577 67.944,26.9990506 63.637,26.9990506 L58.97,26.9990506 L58.97,27 Z M61.843,21.4410648 L63.637,21.4410648 C64.781,21.4410648 65.689,20.5789788 65.689,19.4928265 L65.689,7.5071735 C65.689,6.42102117 64.781,5.55893523 63.637,5.55893523 L61.843,5.55893523 L61.843,21.4410648 Z M140.15,24.2722765 C140.15,25.7790281 138.864,27 137.277,27 C135.69,27 134.404,25.7790281 134.404,24.2722765 L134.404,7.40368521 C134.404,3.31447359 137.895,0 142.202,0 C146.509,0 150,3.31447359 150,7.40368521 L150,10.2007174 C150,12.2457979 149.126,14.0971939 147.713,15.4358956 L147.712,15.4358956 C149.125,16.7745974 150,18.6269428 150,20.6720233 L150,24.2722765 C150,25.7790281 148.714,27 147.127,27 C145.54,27 144.254,25.7790281 144.254,24.2722765 L144.255,22.1474436 C144.255,20.0036219 142.424,18.2652085 140.166,18.2652085 L140.15,24.2722765 Z M140.166,15.0884028 C142.424,15.0884028 144.255,13.3499895 144.255,11.2061678 L144.255,7.5014769 C144.255,6.42956607 143.34,5.5608341 142.211,5.5608341 C141.082,5.5608341 140.166,6.42956607 140.166,7.5014769 L140.166,15.0884028 Z"
          id="path-1"
        />
        <linearGradient
          x1="0%"
          y1="37.642449%"
          x2="100%"
          y2="62.357551%"
          id="linearGradient-3"
        >
          <stop stopColor="#5DBEFC" offset="0%" />
          <stop stopColor="#DD92FE" offset="100%" />
        </linearGradient>
        <filter
          x="0.0%"
          y="0.0%"
          width="100.0%"
          height="100.0%"
          filterUnits="objectBoundingBox"
          id="filter-4"
        >
          <feGaussianBlur stdDeviation="0" in="SourceGraphic" />
        </filter>
      </defs>
      <g
        id="Refresh-Needed-Page"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="We-Need-a-Refresh-Page-(SPAR-18210)"
          transform="translate(-924.000000, -286.000000)"
        >
          <g id="Page-content" transform="translate(797.000000, 286.000000)">
            <g id="Logotype" transform="translate(127.500000, 0.000000)">
              <mask id="mask-2" fill="white">
                <use xlinkHref="#path-1" />
              </mask>
              <use
                id="Logomark"
                fill="#000000"
                fillRule="nonzero"
                xlinkHref="#path-1"
              />
              <g id="Swatch/-Grade" mask="url(#mask-2)">
                <g transform="translate(-3.879310, -12.857143)">
                  <rect
                    id="Rectangle"
                    fill="#000000"
                    x="0"
                    y="0"
                    width="155.172414"
                    height="77.1428571"
                  />
                  <rect
                    id="Grade"
                    fill="url(#linearGradient-3)"
                    filter="url(#filter-4)"
                    x="0"
                    y="0"
                    width="155.172414"
                    height="77.1428571"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

export default HeadlinerColor;
